import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { analyticsAction } from "/src/utils/analytics"

function Tags({ tags }) {
  const siteSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          slugs {
            blog
            tag
          }
        }
      }
    }
  `)
  const { slugs } = siteSettings.site.siteMetadata

  return (
    <ul className="flex flex-wrap text-xs font-medium -m-1">
      {tags &&
        tags
          .filter(({ visibility }) => visibility === "public")
          .map(({ name, slug, accent_color }) => (
            <li className="m-1" key={slug}>
              <Link
                className="inline-flex text-center text-gray-100 py-1 px-3 rounded-full opacity-75 hover:opacity-100 transition duration-150 ease-in-out"
                style={{
                  backgroundColor: accent_color,
                }}
                to={`${slugs.blog}${slugs.tag}/${slug}/`}
                onClick={() => analyticsAction("landing_blog_tag_click")}
              >
                {name}
              </Link>
            </li>
          ))}
    </ul>
  )
}

export default Tags
